// Palette commune à l'onglet Encodage et à ses dialogues (dont la reprise depuis un autre PV)
export const getEncodagePalette = (isDark) => (isDark ? {
  panel: '#1a252f',
  dialogBg: '#1a252f',
  surface: '#22303e',
  previewBg: '#1a252f',
  hover: 'rgba(79, 195, 247, 0.08)',
  selected: 'rgba(79, 195, 247, 0.12)',
  border: '#2d3f4c',
  accent: '#4fc3f7',
  accentHover: '#29b6f6',
  accentSoft: 'rgba(79, 195, 247, 0.15)',
  accentSoftHover: 'rgba(79, 195, 247, 0.25)',
  title: '#4fc3f7',
  text: '#ecf0f1',
  textSecondary: '#95a5a6',
  label: '#bdc3c7',
  mutedSoft: 'rgba(149, 165, 166, 0.15)',
  warning: '#ffb74d',
  warningSoft: 'rgba(255, 183, 77, 0.15)',
  success: '#4ecdc4',
  successSoft: 'rgba(78, 205, 196, 0.15)',
  danger: '#ff6b6b',
  dangerSoft: 'rgba(244, 67, 54, 0.15)'
} : {
  panel: '#f5f5f5',
  dialogBg: '#f5f7fa',
  surface: '#fff',
  previewBg: '#fafbfc',
  hover: 'rgba(25, 118, 210, 0.04)',
  selected: 'rgba(25, 118, 210, 0.06)',
  border: '#dde3ec',
  accent: '#1976d2',
  accentHover: '#1565c0',
  accentSoft: 'rgba(25, 118, 210, 0.08)',
  accentSoftHover: 'rgba(25, 118, 210, 0.14)',
  title: '#1a253c',
  text: '#212529',
  textSecondary: '#6c757d',
  label: undefined,
  mutedSoft: 'rgba(108, 117, 125, 0.1)',
  warning: '#ed6c02',
  warningSoft: 'rgba(237, 108, 2, 0.08)',
  success: '#2e7d32',
  successSoft: 'rgba(46, 125, 50, 0.08)',
  danger: '#d32f2f',
  dangerSoft: 'rgba(211, 47, 47, 0.08)'
});
